import React from 'react'
import {
  HeaderContainer,
  HeaderContent,
  TitleIconPill,
  TitleTextWrapper,
  PageTitle,
  PageSubtitle,
  ScoreDisplayWrapper,
} from './AnalysisSectionHeader.styles'
import { useAnalysisSectionTheme } from './AnalysisSectionThemeContext'
import { Icon } from '../atoms/Icon'
import { IconName } from '../atoms/Icon/Icon.types'
import { SectionColorKey } from '../molecules/AnalysisSidebar/AnalysisSidebar.types'

export interface AnalysisSectionHeaderProps {
  title: string
  subtitle?: React.ReactNode
  icon?: IconName
  sectionColor?: SectionColorKey
  score?: {
    value: number
    maxValue?: number
    label?: string
    variant?: 'success' | 'warning' | 'danger' | 'default' | 'primary'
    tooltip?: string
    /** Defaults to true so analysis headers match across app and public. */
    showProgress?: boolean
  }
  children?: React.ReactNode
}

export const AnalysisSectionHeader: React.FC<AnalysisSectionHeaderProps> = ({
  title,
  subtitle,
  icon: iconProp,
  sectionColor: sectionColorProp,
  score,
  children,
}) => {
  const theme = useAnalysisSectionTheme()
  const icon = iconProp ?? theme.icon
  const sectionColor = sectionColorProp ?? theme.sectionColor

  return (
    <HeaderContainer>
      <HeaderContent>
        {icon && sectionColor && (
          <TitleIconPill $sectionColor={sectionColor}>
            <Icon name={icon} size="small" />
          </TitleIconPill>
        )}
        <TitleTextWrapper>
          <PageTitle $sectionColor={sectionColor}>{title}</PageTitle>
          {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
        </TitleTextWrapper>
      </HeaderContent>
      {score && (
        <ScoreDisplayWrapper
          value={score.value}
          maxValue={score.maxValue || 100}
          label={score.label}
          variant={score.variant}
          tooltip={score.tooltip}
          showProgress={score.showProgress ?? true}
        />
      )}
      {children}
    </HeaderContainer>
  )
}
